export const environment = {
  production: true,
  api_url: 'https://ebopro.app',
  googleMapApiKey: 'AIzaSyDCUwa2ocdg1xKTvzCMO8gHBHgKVscrg6E',
  googleMapId: 'c43a3c750b44597c5e515d8a'
};
